import React, { useEffect, useState, createElement } from 'react';
import { Lock, Clock, HelpCircle, CheckCircle } from 'lucide-react';
import { Footer } from '../components/Footer';
import { VslHeader } from '../components/VslHeader';
import { FakeProgressBar } from '../components/FakeProgressBar';
declare global {
  interface Window {
    fbq: any;
  }
}
export function VslPage() {
  const [showButton, setShowButton] = useState(false);
  const [showSurveyModal, setShowSurveyModal] = useState(false);
  const [videoPlaying, setVideoPlaying] = useState(false);
  useEffect(() => {
    // Show button after 4 minutes and 30 seconds (270 seconds)
    const timer = setTimeout(() => {
      setShowButton(true);
    }, 270000);
    // Listen for Wistia video play event
    const handleWistiaPlay = () => setVideoPlaying(true);
    const checkForPlayer = setInterval(() => {
      const player = document.querySelector('wistia-player[media-id="rjnogmuf71"]');
      if (player) {
        player.addEventListener('play', handleWistiaPlay);
        clearInterval(checkForPlayer);
      }
    }, 500);
    // Add preconnect hints for faster resource loading on mobile
    const preconnect1 = document.createElement('link');
    preconnect1.rel = 'preconnect';
    preconnect1.href = 'https://fast.wistia.com';
    preconnect1.crossOrigin = 'anonymous';
    document.head.appendChild(preconnect1);
    const preconnect2 = document.createElement('link');
    preconnect2.rel = 'preconnect';
    preconnect2.href = 'https://embedwistia-a.akamaihd.net';
    preconnect2.crossOrigin = 'anonymous';
    document.head.appendChild(preconnect2);
    // Preload the Wistia player script for higher priority download
    const preloadPlayer = document.createElement('link');
    preloadPlayer.rel = 'preload';
    preloadPlayer.href = 'https://fast.wistia.com/player.js';
    preloadPlayer.as = 'script';
    document.head.appendChild(preloadPlayer);
    const preloadEmbed = document.createElement('link');
    preloadEmbed.rel = 'preload';
    preloadEmbed.href = 'https://fast.wistia.com/embed/rjnogmuf71.js';
    preloadEmbed.as = 'script';
    document.head.appendChild(preloadEmbed);
    // Load Wistia scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    const wistiaEmbedScript = document.createElement('script');
    wistiaEmbedScript.src = 'https://fast.wistia.com/embed/rjnogmuf71.js';
    wistiaEmbedScript.async = true;
    wistiaEmbedScript.type = 'module';
    document.head.appendChild(wistiaEmbedScript);
    // Load LeadConnector form embed script
    const formEmbedScript = document.createElement('script');
    formEmbedScript.src = 'https://link.msgsndr.com/js/form_embed.js';
    formEmbedScript.async = true;
    document.head.appendChild(formEmbedScript);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '2842475396100201');
    window.fbq('track', 'PageView');
    window.fbq('track', 'ViewContent');
    return () => {
      clearTimeout(timer);
      clearInterval(checkForPlayer);
      const player = document.querySelector('wistia-player[media-id="rjnogmuf71"]');
      if (player) player.removeEventListener('play', handleWistiaPlay);
      document.head.removeChild(playerScript);
      document.head.removeChild(wistiaEmbedScript);
      document.head.removeChild(preconnect1);
      document.head.removeChild(preconnect2);
      document.head.removeChild(preloadPlayer);
      document.head.removeChild(preloadEmbed);
      document.head.removeChild(formEmbedScript);
    };
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-[#00f7fc] selection:text-black overflow-x-hidden" data-id="element-4595">
      {/* Inline Wistia swatch style for instant placeholder render */}
      <style dangerouslySetInnerHTML={{
      __html: `wistia-player[media-id='rjnogmuf71']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/rjnogmuf71/swatch'); display: block; filter: blur(5px); padding-top:56.25%; }`
    }} data-id="element-4596" />

      {/* Header */}
      <VslHeader data-id="element-4597" />

      {/* Meta Pixel Noscript */}
      <noscript data-id="element-4598">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=Lead&noscript=1" alt="" data-id="element-4599" />
      </noscript>

      {/* Background Image Layer */}
      <div className="absolute top-0 left-0 w-full h-[400px] md:h-[600px] z-0 opacity-60" data-id="element-4600">
        <img src="https://cdn.magicpatterns.com/uploads/owSR6X5Pw8KuRfkif7sGzk/6936d7f7169a421d1ba8a294.png" alt="" className="w-full h-full object-cover" style={{
        maskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)',
        WebkitMaskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)'
      }} data-id="element-4601" />
      </div>

      {/* Main Content Container */}
      <main className="relative z-10 max-w-5xl mx-auto px-4 py-4 md:py-8 flex flex-col items-center text-center pt-14 md:pt-20" data-id="element-4602">
        {/* ABOVE THE FOLD */}
        <div className="mb-4 md:mb-6 space-y-4 md:space-y-4" data-id="element-4603">
          <h1 className="text-2xl md:text-4xl lg:text-5xl xl:text-6xl font-black leading-tight tracking-tight" data-id="element-4604">
            Deja De Adivinar Qué Vender:{' '}
            <span className="text-[#FDB931]" data-id="element-4605">
              Instala Tu 48Hrs AI Cash Machine
            </span>{' '}
            Y Lanza Tu Producto Digital En Menos De 2 Días.
          </h1>

          <h2 className="text-xs md:text-xl lg:text-2xl text-gray-300 font-medium max-w-3xl mx-auto leading-snug md:leading-relaxed" data-id="element-4606">
            Sin seguidores, sin meses de estudio y sin "cansancio mental". Te
            ayudamos a construir un producto real, una página de ventas y
            anuncios listos para validar con IA mientras otros siguen
            "intentando" entender el marketing.
          </h2>
        </div>

        {/* VIDEO PLAYER SECTION */}
        <div className="w-full mb-6 md:mb-8" data-id="element-4607">
          <div className="relative bg-gray-900 border border-[#00f7fc]/30 overflow-hidden shadow-2xl" style={{
          boxShadow: '0 0 10px rgba(0, 247, 252, 0.15), 0 0 20px rgba(0, 247, 252, 0.1), 0 0 30px rgba(0, 247, 252, 0.08)'
        }} data-id="element-4608">
            <wistia-player media-id="rjnogmuf71" aspect="1.7777777777777777" preload="auto" data-id="element-4609"></wistia-player>
            <FakeProgressBar isPlaying={videoPlaying} data-id="element-4610" />
          </div>
        </div>

        {/* COPY BELOW VIDEO */}
        <div className="max-w-2xl mx-auto space-y-8 mb-6 md:mb-12" data-id="element-4611"></div>

        {/* TIMED BUTTON SECTION */}
        {showButton ? <div className="w-full max-w-2xl animate-fade-in-up" data-id="element-4612">
            <div className="bg-white/5 border border-[#00f7fc]/20 rounded-2xl p-4 md:p-10 backdrop-blur-sm relative overflow-hidden" data-id="element-4613">
              {/* Glow effect */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1/2 bg-[#00f7fc]/10 blur-3xl rounded-full pointer-events-none" data-id="element-4614"></div>

              <div className="relative z-10" data-id="element-4615">
                <button type="button" onClick={() => setShowSurveyModal(true)} className="group relative w-full bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] text-black font-black text-lg md:text-xl lg:text-2xl uppercase tracking-wide rounded-xl py-5 px-6 shadow-[0_0_30px_rgba(253,185,49,0.3)] transition-all duration-300 transform hover:scale-[1.02] mb-4" data-id="element-4616">
                  APLICAR PARA CONSTRUIR MI MÁQUINA
                  {/* Shine effect */}
                  <div className="absolute inset-0 rounded-xl overflow-hidden pointer-events-none" data-id="element-4617">
                    <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-[#00D9FF]/60 to-transparent skew-x-[-25deg] group-hover:animate-shine" data-id="element-4618" />
                  </div>
                </button>

                <div className="text-center" data-id="element-4619">
                  <p className="text-sm md:text-base text-gray-300 font-medium" data-id="element-4620">
                    Requiere una inversión mínima de $500–$1,000 para ejecución
                    y pauta.
                  </p>
                  <p className="text-xs md:text-sm text-gray-500 mt-1" data-id="element-4621">
                    Solo para personas listas para implementar hoy.
                  </p>
                </div>
              </div>
            </div>
          </div> : <div className="h-4" data-id="element-4622"></div>}

        {showButton && <div className="mt-8 md:mt-16 w-full max-w-2xl animate-fade-in-up delay-200" data-id="element-4623">
            {/* Scarcity */}
            <div className="flex flex-col items-center gap-2 mb-6 md:mb-12 text-xs md:text-sm text-[#00f7fc]/80 font-medium uppercase tracking-widest" data-id="element-4624">
              <p data-id="element-4625">Acceso disponible por tiempo limitado</p>
              <p className="text-xs text-gray-600 normal-case tracking-normal" data-id="element-4626">
                Esta página no se comparte públicamente
              </p>
            </div>

            {/* FAQ */}
            <div className="border-t border-gray-800 pt-6 md:pt-12 text-left space-y-4 md:space-y-8" data-id="element-4627">
              <div className="space-y-2" data-id="element-4628">
                <h3 className="text-sm md:text-base text-white font-bold flex items-center gap-2" data-id="element-4629">
                  <HelpCircle className="w-5 h-5 text-cyan-400" data-id="element-4630" />
                  ¿Es para principiantes?
                </h3>
                <p className="text-gray-400 pl-7 text-xs md:text-sm leading-relaxed" data-id="element-4631">
                  Es para personas cansadas de improvisar.
                </p>
              </div>

              <div className="space-y-2" data-id="element-4632">
                <h3 className="text-sm md:text-base text-white font-bold flex items-center gap-2" data-id="element-4633">
                  <HelpCircle className="w-5 h-5 text-cyan-400" data-id="element-4634" />
                  ¿Necesito experiencia previa?
                </h3>
                <p className="text-gray-400 pl-7 text-xs md:text-sm leading-relaxed" data-id="element-4635">
                  No. Necesitas entender el orden correcto.
                </p>
              </div>

              <div className="space-y-2" data-id="element-4636">
                <h3 className="text-sm md:text-base text-white font-bold flex items-center gap-2" data-id="element-4637">
                  <CheckCircle className="w-5 h-5 text-cyan-400" data-id="element-4638" />
                  ¿Cuándo empiezo?
                </h3>
                <p className="text-gray-400 pl-7 text-xs md:text-sm leading-relaxed" data-id="element-4639">
                  Acceso inmediato.
                </p>
              </div>
            </div>
          </div>}
      </main>
      <Footer data-id="element-4640" />
      {/* Survey Modal */}
      {showSurveyModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={() => setShowSurveyModal(false)} data-id="element-4641">
          <div className="relative w-full max-w-2xl bg-[#111] border border-[#00f7fc]/30 rounded-2xl shadow-[0_0_30px_rgba(0,247,252,0.15)] p-4 md:p-6" onClick={e => e.stopPropagation()} data-id="element-4642">
            <button onClick={() => setShowSurveyModal(false)} className="absolute top-3 right-3 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors" data-id="element-4643">
              ✕
            </button>
            <div className="w-full rounded-xl overflow-hidden" style={{
          minHeight: '500px'
        }} data-id="element-4644">
              <iframe src="https://api.leadconnectorhq.com/widget/survey/83dMoovqchIANI2mgHUJ" style={{
            border: 'none',
            width: '100%',
            height: '600px'
          }} scrolling="no" id="83dMoovqchIANI2mgHUJ" title="survey" data-id="element-4645" />
            </div>
          </div>
        </div>}
    </div>;
}